import { supabase } from "@/integrations/supabase/client";
import { trackEvent } from "@/lib/trackEvent";

/**
 * Track share events via edge function (server-side insertion)
 * This prevents client-side RLS bypass and ensures IP addresses are hashed
 */
export async function trackShareEvent(
  platform: string,
  url: string,
  title: string,
  articleId?: string
) {
  trackEvent('conversion', { type: 'share', platform });

  try {
    const { error } = await supabase.functions.invoke('track-analytics', {
      body: {
        event_type: 'share',
        platform,
        url,
        title,
        article_id: articleId,
        user_agent: navigator.userAgent,
      }
    });

    if (error) {
      console.error('Error tracking share:', error);
    }
  } catch (err) {
    // Silently fail - tracking should not break user experience
    console.error('Failed to track share event:', err);
  }
}
